import { Alert, Box } from '@mui/material';
import { Checkbox } from '@sm-dashboard/ui-components';

interface AiFillConfirmationProps {
  confirmed: boolean;
  onConfirmedChange: (checked: boolean) => void;
  saveButtonLabel: string;
}

/** Shown after AI fill: makes clear nothing is saved until the save button is clicked. */
export const AiFillConfirmation = ({ confirmed, onConfirmedChange, saveButtonLabel }: AiFillConfirmationProps) => (
  <Alert severity={confirmed ? 'success' : 'warning'}>
    הפרטים מולאו אוטומטית מתוך המודעה <strong>ועדיין לא נשמרו</strong>. עברו על הפרטים ותקנו במידת הצורך — השמירה
    מתבצעת רק בלחיצה על "{saveButtonLabel}".
    <Box sx={{ mt: 1 }}>
      <Checkbox
        checked={confirmed}
        onChange={(_, checked) => onConfirmedChange(checked)}
        label="בדקתי שהפרטים שמולאו אוטומטית מהמודעה נכונים"
      />
    </Box>
  </Alert>
);
